import { Storefront } from "@phosphor-icons/react";

// Shared ordering-page header (No AI kiosk / online / QR, and the AI Cashier's Browse Menu).
export function OrderHeader({ isKiosk, mode, venueName, logoBind = {}, children }) {
  return (
    <header className={`sticky top-0 z-30 bg-white/80 backdrop-blur-xl border-b border-[rgba(28,25,23,0.08)] ${isKiosk ? "px-8 py-6" : "px-4 py-3"}`}>
      <div className="max-w-[1300px] mx-auto flex items-center justify-between">
        <div>
          <div className="flex items-center gap-2" {...logoBind} data-testid="co-kiosk-logo">
            <div className={`${isKiosk ? "w-10 h-10" : "w-7 h-7"} rounded-md bg-[var(--terracotta)] flex items-center justify-center`}>
              <Storefront size={isKiosk ? 22 : 16} color="#fff" weight="fill" />
            </div>
            <div>
              <div className={`font-heading font-semibold ${isKiosk ? "text-xl" : "text-base"}`}>{venueName}</div>
              <div className="text-[10px] uppercase tracking-[0.18em] text-[var(--ink-500)]">{mode === "qr" ? "Scan & order" : isKiosk ? "Self-serve kiosk" : "Order online"}</div>
            </div>
          </div>
        </div>
        {children}
      </div>
    </header>
  );
}
